import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';

const Webhooks = () => import('./pages');

const moduleRoute = {
  path: 'company-settings/webhooks',
  name: 'Webhooks',
  component: Webhooks,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.WEBHOOKS,
      action: USER_ACTIONS.READ,
    },
    breadcrumb: {
      parents: [{ key: 'developer-tools', disabled: true }],
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
